import { render, staticRenderFns } from "./CreateRoomComponent.vue?vue&type=template&id=294c63da"
import script from "./CreateRoomComponent.vue?vue&type=script&lang=ts"
export * from "./CreateRoomComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports